var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn',{attrs:{"type":_vm.type,"icon":_vm.icon,"href":_vm.href,"title":_vm.title,"action":_vm.action,"delform":_vm.delform,"postform":_vm.postform,"formid":_vm.formid,"light":"","bar":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }